























































import { Component,Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";
import { GapTransportationCoordinationReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class ApptDateFilter extends Vue {
 @Model("change") readonly filter!: GapTransportationCoordinationReportFilter;
  id = "appt-date-filter-popover";
  target = "appt-date-filter-target";
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.filter.apptDate = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    
  }
}
